import type { EffectDefinition } from "./effectTypes";

export type HalftoneParameters = {
  cellSize: number;
  angle: number;
  dotGain: number;
  threshold: number;
  invert: boolean;
  foreground: string;
  background: string;
};

export const halftoneDefinition: EffectDefinition<HalftoneParameters> = {
  id: "halftone",
  version: 1,
  name: "Halftone",
  category: "print",
  description: "Luminance-driven dot halftone for image and video.",
  defaults: {
    cellSize: 10,
    angle: 45,
    dotGain: 1,
    threshold: 0,
    invert: false,
    foreground: "#f5f3ee",
    background: "#111111",
  },
  parameters: [
    { id: "cellSize", label: "Cell size", type: "number", min: 4, max: 32, step: 1 },
    { id: "angle", label: "Angle", type: "number", min: 0, max: 180, step: 1 },
    { id: "dotGain", label: "Dot gain", type: "number", min: 0.25, max: 2, step: 0.05 },
    { id: "threshold", label: "Threshold", type: "number", min: -1, max: 1, step: 0.05 },
    { id: "invert", label: "Invert", type: "boolean" },
    { id: "foreground", label: "Ink", type: "color" },
    { id: "background", label: "Paper", type: "color" },
  ],
  capabilities: {
    image: true,
    video: true,
    vector: true,
    gpu: true,
  },
};
